enum AccountPlanType {
  Basic = 'Basic',
  Pro = 'Pro',
  Premium = 'Premium',
  Unlimited = 'Unlimited',
  BroadcastLite = 'BroadcastLite',
  BroadcastStart = 'BroadcastStart',
  BroadcastRise = 'BroadcastRise',
  BroadcastPrime = 'BroadcastPrime',
}

export default AccountPlanType;
